import { useQueryParamHelper } from '@shared/core/queryString';

export const usePurchaseContextIdFromLocation = () => {
  const { getValueString } = useQueryParamHelper();
  return getValueString('pcId');
};
